import cards from './card/routes'
import charts from './charts-and-maps/routes'
import routes from './extensions/routes'


export default [...cards, ...charts, ...routes]